type Sales = {
  id: string
  salesDate: string
  isDiscount: boolean
  unitPrice: number
  quantity: number
  subjectPrice: number
  subjectName: string
  subSubjectName: string | undefined
  paymentMethod: string
}

export type InputReceipts = {
  accountDescription: AccountDescriptionType
  receiptPrice: number
  receiptDate: string
}

export const SortKeyType = {
  CheckinDate: 'checkin_date',
  CustomerName: 'accounts_receivable_master_name',
  IsDiscount: 'is_discount',
  TotalPrice: 'total_price',
} as const
export type SortKeyType = (typeof SortKeyType)[keyof typeof SortKeyType]

export const SortOrderType = {
  Asc: 'asc',
  Desc: 'desc',
} as const
export type SortOrderType = (typeof SortOrderType)[keyof typeof SortOrderType]

export const AccountDescriptionType = {
  AccountsReceivable: '売掛金',
  BrokerageCommission: '斡旋手数料',
  SettlementCommission: '決済手数料',
  PointUsage: 'ポイント利用',
  PointCharge: 'ポイント負担',
  TransferFee: '振込手数料',
  Other: 'その他',
} as const
export type AccountDescriptionType = (typeof AccountDescriptionType)[keyof typeof AccountDescriptionType]

export type AccountsReceivableSearchCondition = {
  page?: number
  sortKey?: SortKeyType
  sortOrder?: SortOrderType
  checkinFrom: string | undefined
  checkinTo: string | undefined
  checkoutFrom: string | undefined
  checkoutTo: string | undefined
  customerName: string | undefined
  salesType: 'sales' | 'discount' | undefined
  reconciledStatus: 'reconciled' | 'unreconciled' | undefined
}

export interface AccountsReceivable {
  id: string
  checkinAt: string | undefined
  nights: number | undefined
  arDate: string
  receiptGroupKey: string
  isDiscount: boolean
  customer: {
    id: string
    code: string
    name: string
  }
  reservationUuid: string | undefined
  reservationId: string | undefined
  guestName: string | undefined
  totalPrice: number
  isReconciled: boolean
  sales: Array<Sales>
  receiptAt: string[]
  accountDescriptions: string[]
}

export interface AccountsReceivableReceipt {
  id: string
  accountDescription: string
  receiptPrice: number
  reconciliationAt: string
  receiptAt: string
  isDiscount: boolean
  customer: {
    id: string
    code: string
    name: string
  }
}

export interface AccountsReceivableBalance {
  customerCode: string
  customerName: string
  isDiscount: boolean
  prevBalancePrice: number
  accountsReceivablePrice: number
  currentReceiptPrice: number
  currentBalancePrice: number
}

export interface FetchAccountsReceivableResponse {
  indicator: {
    totalAccountsReceivable: number
    totalReceiptPrice: number
    accountsReceivableBalance: number
  }
  hasMore: boolean
  total: number
  results: AccountsReceivable[]
  isEnabledAllSelect: boolean
  selectionItems: Array<{ id: string; receiptGroupKey: string; subjectPrice: number; isDiscount: boolean }>
}
